/* The Surfboard Showroom — Ocean OS runtime (CIVA build v2.1) */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };

  /* ---------------- animated ocean ---------------- */
  function ocean(c) {
    if (c.__x) return; c.__x = true;
    var ctx = c.getContext('2d'); if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), w = 0, h = 0, t = Math.random() * 100, mx = 0, tmx = 0, running = true;
    var L = [
      { a: 10, f: .010, s: .55, y: .16, fill: 'rgba(54,241,220,.10)', crest: 'rgba(54,241,220,.65)' },
      { a: 16, f: .007, s: .42, y: .30, fill: 'rgba(125,216,255,.10)', crest: 'rgba(125,216,255,.45)' },
      { a: 22, f: .0055, s: .33, y: .46, fill: 'rgba(13,74,85,.85)', crest: 'rgba(125,216,255,.25)' },
      { a: 28, f: .0045, s: .24, y: .63, fill: 'rgba(7,34,48,.95)', crest: null },
      { a: 30, f: .0038, s: .17, y: .80, fill: 'rgba(4,22,31,1)', crest: null }
    ];
    function size() { w = c.clientWidth; h = c.clientHeight; c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size(); window.addEventListener('resize', size);
    (c.parentElement || document).addEventListener('pointermove', function (e) { tmx = (e.clientX / window.innerWidth - .5); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { running = en[0].isIntersecting; if (running && !RM) frame(); }).observe(c);
    function frame() {
      mx += (tmx - mx) * .04;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < L.length; i++) {
        var l = L[i], pts = [];
        for (var x = 0; x <= w + 10; x += 10) {
          var y = h * l.y + Math.sin(x * l.f + t * l.s + i * 1.7) * l.a + Math.sin(x * l.f * 2.4 - t * l.s * 1.3) * l.a * .35 + mx * 18 * (i + 1) * Math.sin(x * .002);
          pts.push([x, y]);
        }
        ctx.beginPath(); ctx.moveTo(0, h);
        for (var p = 0; p < pts.length; p++) ctx.lineTo(pts[p][0], pts[p][1]);
        ctx.lineTo(w, h); ctx.closePath(); ctx.fillStyle = l.fill; ctx.fill();
        if (l.crest) {
          ctx.beginPath();
          for (var q = 0; q < pts.length; q++) q ? ctx.lineTo(pts[q][0], pts[q][1]) : ctx.moveTo(pts[q][0], pts[q][1]);
          ctx.strokeStyle = l.crest; ctx.lineWidth = i ? 1 : 1.6; ctx.shadowColor = l.crest; ctx.shadowBlur = i ? 0 : 12; ctx.stroke(); ctx.shadowBlur = 0;
        }
      }
      t += .016;
      if (running && !RM) requestAnimationFrame(frame);
    }
    frame();
  }

  /* ---------------- reveal + counters ---------------- */
  function reveal() {
    var els = $$('[data-x-reveal]:not(.is-in), .x-journey:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = e.target.getAttribute('data-x-delay'); if (d) e.target.style.transitionDelay = d + 'ms';
        e.target.classList.add('is-in'); io.unobserve(e.target);
        $$('[data-x-count]', e.target).concat(e.target.hasAttribute('data-x-count') ? [e.target] : []).forEach(count);
      });
    }, { threshold: .15 });
    els.forEach(function (e) { io.observe(e); });
  }
  function count(el) {
    if (el.__c) return; el.__c = true;
    var raw = el.getAttribute('data-x-count'), m = raw.match(/^(\D*)(\d+)(.*)$/); if (!m || RM) { el.textContent = raw; return; }
    var end = parseInt(m[2], 10), t0 = performance.now();
    (function step(t) { var k = Math.min(1, (t - t0) / 1400); k = 1 - Math.pow(1 - k, 3); el.textContent = m[1] + Math.round(end * k) + m[3]; if (k < 1) requestAnimationFrame(step); })(t0);
  }

  /* ---------------- 3D tilt ---------------- */
  function tilt(el) {
    if (el.__t || RM || window.matchMedia('(hover: none)').matches) return; el.__t = true;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) translateY(-4px)';
    });
    el.addEventListener('pointerleave', function () { el.style.transform = ''; });
  }

  /* ---------------- scanner ---------------- */
  function scanner(root) {
    if (root.__s) return; root.__s = true;
    var items = $$('.x-scan__item', root), dots = $$('.x-scan__dots button', root), i = 0, timer;
    if (items.length < 2) return;
    function go(n) { items[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active'); }
    function play() { clearInterval(timer); if (!RM) timer = setInterval(function () { go(i + 1); }, 4800); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
    root.addEventListener('pointerenter', function () { clearInterval(timer); });
    root.addEventListener('pointerleave', play);
    play();
  }

  /* ---------------- live surf (Open-Meteo, no key) ---------------- */
  var DIRS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
  function compass(d) { return DIRS[Math.round(((d % 360) / 22.5)) % 16]; }
  function fmtTime(s) { var d = new Date(s); return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }); }
  function surf(el) {
    if (el.__f) return; el.__f = true;
    var lat = el.getAttribute('data-lat'), lon = el.getAttribute('data-lon'), face = parseFloat(el.getAttribute('data-face') || '90');
    var tz = encodeURIComponent('America/New_York');
    var mu = 'https://marine-api.open-meteo.com/v1/marine?latitude=' + lat + '&longitude=' + lon + '&current=wave_height,wave_direction,wave_period,swell_wave_height,swell_wave_period,sea_surface_temperature&hourly=wave_height,sea_level_height_msl&forecast_days=2&timezone=' + tz;
    var wu = 'https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lon + '&current=temperature_2m,wind_speed_10m,wind_direction_10m&wind_speed_unit=mph&temperature_unit=fahrenheit&timezone=' + tz;
    function set(k, v) { $$('[data-k="' + k + '"]', el).forEach(function (n) { n.textContent = v; }); }
    Promise.all([fetch(mu).then(function (r) { return r.json(); }), fetch(wu).then(function (r) { return r.json(); })]).then(function (res) {
      var m = res[0], w = res[1], c = m.current || {}, wc = w.current || {};
      var ft = c.wave_height != null ? c.wave_height * 3.281 : null;
      if (ft != null) set('wave', ft < 10 ? ft.toFixed(1) : Math.round(ft));
      if (c.wave_period != null) set('period', Math.round(c.wave_period));
      if (c.wave_direction != null) { set('dir', compass(c.wave_direction)); var a = $('[data-k="arrow"]', el); if (a) a.style.transform = 'rotate(' + (c.wave_direction + 180) + 'deg)'; }
      if (c.sea_surface_temperature != null) set('water', Math.round(c.sea_surface_temperature * 9 / 5 + 32));
      var offshore = false;
      if (wc.wind_speed_10m != null) set('wind', Math.round(wc.wind_speed_10m));
      if (wc.wind_direction_10m != null) {
        set('winddir', compass(wc.wind_direction_10m));
        var rel = Math.abs(((wc.wind_direction_10m - face) % 360 + 540) % 360 - 180);
        offshore = rel > 120; set('windtype', rel > 120 ? 'Offshore' : rel < 60 ? 'Onshore' : 'Cross-shore');
      }
      if (wc.temperature_2m != null) set('air', Math.round(wc.temperature_2m));
      var r = el.querySelector('[data-k="rating"]');
      if (r && ft != null) {
        var lbl = ft < 1 ? 'Flat · wax day' : ft < 2 ? 'Small · log day' : ft < 3.5 ? 'Fun size' : ft < 6 ? 'Good · go surf' : 'Pumping';
        if (offshore && ft >= 1) lbl += ' · offshore';
        r.innerHTML = '<i></i>' + lbl; r.className = 'x-pill ' + (ft < 1 ? 'x-pill--mute' : ft < 3.5 ? 'x-pill--ok' : 'x-pill--warn');
      }
      var hr = m.hourly || {}, times = hr.time || [], now = Date.now(), start = 0;
      for (var i = 0; i < times.length; i++) { if (new Date(times[i]).getTime() >= now - 3600e3) { start = i; break; } }
      var sl = hr.sea_level_height_msl || [];
      for (var j = Math.max(start, 1); j < sl.length - 1; j++) {
        if (sl[j] == null) continue;
        if (sl[j] > sl[j - 1] && sl[j] >= sl[j + 1]) { set('tide', 'High'); set('tidetime', fmtTime(times[j])); break; }
        if (sl[j] < sl[j - 1] && sl[j] <= sl[j + 1]) { set('tide', 'Low'); set('tidetime', fmtTime(times[j])); break; }
      }
      var wh = (hr.wave_height || []).slice(start, start + 24).filter(function (v) { return v != null; });
      if (wh.length > 2) {
        var mx = Math.max.apply(null, wh) * 1.15 || 1, W = 300, H = 48, d = '';
        wh.forEach(function (v, k) { var x = k / (wh.length - 1) * W, y = H - (v / mx) * (H - 6) - 3; d += (k ? 'L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1); });
        var p = $$('[data-k="spark"]', el); if (p[0]) p[0].setAttribute('d', d);
        var f = $('[data-k="sparkfill"]', el); if (f) f.setAttribute('d', d + 'L' + W + ' ' + H + 'L0 ' + H + 'Z');
      }
      el.classList.add('is-live');
    }).catch(function () { el.classList.add('is-offline'); var r = $('[data-k="rating"]', el); if (r) { r.innerHTML = 'Report offline'; r.className = 'x-pill x-pill--mute'; } });
  }

  /* ---------------- shipping engine ---------------- */
  var RATES = window.TSS_RATES || null;
  function parseLen(s) {
    if (!s) return null;
    s = String(s).replace(/[’′`]/g, "'").replace(/[”″]/g, '"');
    var m = s.match(/(\d{1,2})\s*'\s*(\d{1,2}(?:\.\d+)?)?/);
    if (!m) return null;
    var inch = parseInt(m[1], 10) * 12 + (m[2] ? parseFloat(m[2]) : 0);
    return inch >= 36 && inch <= 216 ? inch : null;
  }
  function fmtLen(i) { return Math.floor(i / 12) + "'" + Math.round(i % 12) + '"'; }
  function classFor(inch) {
    if (!RATES || inch == null) return null;
    for (var i = 0; i < RATES.classes.length; i++) if (inch <= RATES.classes[i].max) return RATES.classes[i];
    return RATES.classes[RATES.classes.length - 1];
  }
  function rateText(cls, region) { var v = cls && cls.rates ? cls.rates[region] : null; return v == null ? 'Quote' : money(v); }
  function tagShip() {
    $$('[data-x-len]').forEach(function (el) {
      if (el.__l) return; el.__l = true;
      var cls = classFor(parseLen(el.getAttribute('data-x-len')));
      el.innerHTML = 'Ships <b>' + (cls ? cls.short : 'Ground') + '</b>';
    });
  }

  /* calculator */
  function calc(root) {
    if (root.__k || !RATES) return; root.__k = true;
    var mode = 'board', region = RATES.regions[1].id, len = parseInt(root.getAttribute('data-default') || '96', 10);
    var slider = $('input[type=range]', root), out = $('[data-c="len"]', root), svg = $('.x-board-vis svg', root);
    var regionsWrap = $('.x-regions', root);
    regionsWrap.innerHTML = RATES.regions.map(function (r) { return '<button type="button" data-r="' + r.id + '">' + r.label + '</button>'; }).join('') + '<button type="button" data-r="pickup">Showroom pickup</button>';
    function set(k, v) { var n = $('[data-c="' + k + '"]', root); if (n) n.textContent = v; }
    function paint() {
      $$('.x-seg button', root).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-m') === mode); });
      $$('.x-regions button', root).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-r') === region); });
      $('[data-c="boardctl"]', root).style.display = mode === 'board' ? '' : 'none';
      slider.style.setProperty('--p', ((len - slider.min) / (slider.max - slider.min) * 100) + '%');
      out.textContent = fmtLen(len);
      if (svg) svg.style.width = (len / slider.max * 100) + '%';
      var price, cls, rows = [], notes = [];
      if (region === 'pickup') {
        price = 'FREE'; set('class', 'Showroom pickup'); set('classpill', 'Jupiter, FL');
        rows = [['Where', RATES.pickup.address], ['When', RATES.pickup.when], ['Bring', 'Your order email']];
        notes = RATES.pickup.notes;
      } else if (mode === 'gear') {
        set('class', 'Small parcel'); set('classpill', 'UPS / USPS');
        price = money(RATES.gear.standard);
        rows = [['Standard', money(RATES.gear.standard) + ' · ' + RATES.gear.transit], ['Express', money(RATES.gear.express) + ' · ' + RATES.gear.expressTransit], ['Showroom pickup', 'Free']];
        notes = RATES.gear.notes;
      } else {
        cls = classFor(len); set('class', cls.label); set('classpill', cls.carrier);
        price = rateText(cls, region);
        rows = [['Transit', cls.transit], ['Packaging', cls.pack], ['Delivery', cls.delivery]];
        notes = (cls.notes || []).concat(RATES.boardNotes || []);
      }
      set('price', price);
      $('[data-c="rows"]', root).innerHTML = rows.map(function (r) { return '<div><span>' + r[0] + '</span><b>' + r[1] + '</b></div>'; }).join('');
      $('[data-c="notes"]', root).innerHTML = notes.map(function (n) { return '<li>' + n + '</li>'; }).join('');
    }
    slider.addEventListener('input', function () { len = parseInt(slider.value, 10); paint(); });
    $$('.x-seg button', root).forEach(function (b) { b.addEventListener('click', function () { mode = b.getAttribute('data-m'); paint(); }); });
    regionsWrap.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; region = b.getAttribute('data-r'); paint(); });
    paint();
  }

  /* product page delivery */
  function pdp(root) {
    if (root.__p || !RATES) return; root.__p = true;
    var data = JSON.parse($('script[type="application/json"]', root).textContent);
    var region = RATES.regions[1].id, last = null;
    var regionsWrap = $('.x-regions', root);
    regionsWrap.innerHTML = RATES.regions.map(function (r) { return '<button type="button" data-r="' + r.id + '">' + r.label + '</button>'; }).join('');
    regionsWrap.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; region = b.getAttribute('data-r'); render(current()); });
    function current() {
      var id = new URLSearchParams(location.search).get('variant'), v = null;
      data.variants.forEach(function (x) { if (String(x.id) === id) v = x; });
      return v || data.variants.filter(function (x) { return x.available; })[0] || data.variants[0];
    }
    function set(k, v, html) { var n = $('[data-p="' + k + '"]', root); if (n) n[html ? 'innerHTML' : 'textContent'] = v; }
    function render(v) {
      $$('.x-regions button', root).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-r') === region); });
      $$('.x-sizes tr[data-v]', document).forEach(function (tr) { tr.classList.toggle('is-sel', tr.getAttribute('data-v') === String(v.id)); });
      var rows = [], inch = data.board ? (parseLen(v.title) || parseLen(data.title)) : null, cls = data.board ? (classFor(inch) || RATES.classes[1]) : null;
      if (cls) {
        set('class', cls.label); set('pill', cls.carrier); set('len', inch ? fmtLen(inch) + ' board' : 'Board');
        rows.push(['Ship to ' + RATES.regions.filter(function (r) { return r.id === region; })[0].label, rateText(cls, region), '']);
        rows.push(['Transit', cls.transit, '']);
        rows.push(['Packaging', cls.pack, '']);
        rows.push(['Showroom pickup', 'FREE', 'is-pick']);
      } else {
        set('class', 'Small parcel'); set('pill', 'UPS / USPS'); set('len', 'Gear');
        rows.push(['Standard', money(RATES.gear.standard), '']);
        rows.push(['Express', money(RATES.gear.express), '']);
        rows.push(['Transit', RATES.gear.transit, '']);
        rows.push(['Showroom pickup', 'FREE', 'is-pick']);
      }
      set('rows', rows.map(function (r) { return '<div class="' + r[2] + '"><span>' + r[0] + '</span><b>' + r[1] + '</b></div>'; }).join(''), true);
      var notes = [];
      if (v.price >= 50000) notes.push('Adult signature required on delivery (orders over $500).');
      if (cls && cls.notes) notes = notes.concat(cls.notes);
      if (data.board) notes.push('Boards can’t ship to PO boxes or APO addresses.');
      set('notes', notes.map(function (n) { return '<li>' + n + '</li>'; }).join(''), true);
    }
    render(current());
    setInterval(function () { var v = current(); if (v !== last) { last = v; render(v); } }, 500);
  }

  function dockNav(btn) {
    if (btn.__d) return; btn.__d = true;
    btn.addEventListener('click', function () { var t = document.getElementById(btn.getAttribute('data-x-dock')); if (t) t.scrollBy({ left: (btn.getAttribute('data-dir') === 'prev' ? -1 : 1) * t.clientWidth * .8, behavior: 'smooth' }); });
  }
  function rangeFill() { $$('.x-range input[type=range]').forEach(function (r) { if (r.__r) return; r.__r = true; var f = function () { r.style.setProperty('--p', ((r.value - r.min) / (r.max - r.min) * 100) + '%'); }; r.addEventListener('input', f); f(); }); }

  function boot() {
    $$('[data-x-ocean]').forEach(ocean);
    $$('[data-x-tilt]').forEach(tilt);
    $$('[data-x-scanner]').forEach(scanner);
    $$('[data-x-surf]').forEach(surf);
    $$('[data-x-calc]').forEach(calc);
    $$('[data-x-pdp]').forEach(pdp);
    $$('[data-x-dock]').forEach(dockNav);
    rangeFill(); tagShip(); reveal();
  }
  window.TSSX = { boot: boot, parseLen: parseLen, classFor: classFor };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
